import { Controller, useForm } from 'react-hook-form';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MaskedInput from 'react-text-mask';

type FormProps = {
  verification: {
    code: string;
  };
};

type Props = {
  onSubmit: (data: any) => void;
  loading?: boolean;
};

export default function AttendanceDeclarationForm({ onSubmit, loading }: Props) {
  const {
    control,
    register,
    trigger,
    getValues,
    formState: { errors }
  } = useForm<FormProps>();

  const submit = () => {
    onSubmit(getValues());
  };

  const validateCode = (value: string) => {
    const codePattern = /^[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/;
    return codePattern.test(value) || 'Código deve seguir o padrão XXXX-XXXX';
  };

  return (
    <Box>
      <form
        id="attendance-declaration-form"
        onSubmit={e => e.preventDefault()}
        onKeyPress={e => {
          if (e.code === 'Enter') {
            submit();
          }
        }}
        autoComplete="on"
      >
        <Controller
          name="verification.code"
          control={control}
          render={() => (
            <MaskedInput
              mask={[
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                '-',
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/
              ]}
              className="form-control"
              guide={false}
              render={(ref, props) => (
                <TextField
                  {...props}
                  inputRef={ref}
                  helperText={errors?.verification?.code && errors?.verification?.code.message}
                  error={errors?.verification?.code && true}
                  variant="standard"
                  inputProps={{
                    maxLength: 13,
                    style: { textTransform: 'uppercase' }
                  }}
                  fullWidth
                  placeholder="Código de validação"
                  sx={{ mb: 4 }}
                  {...register('verification.code', {
                    validate: value => validateCode(value) || 'Código deve seguir o padrão XXXX-XXXX',
                    required: 'Campo Obrigatório',
                    onBlur: () => trigger('verification.code'),
                    onChange: (event: any) => {
                      const value = event.target.value;
                      if (value.length === 13) {
                        trigger('verification.code');
                      }
                    }
                  })}
                />
              )}
            />
          )}
        />

        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <LoadingButton
            sx={{ display: 'inline-flex', justifyContent: 'space-between' }}
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            onClick={() => submit()}
            loading={loading ?? false}
            disabled={getValues('verification.code') === '' || Object.keys(errors).length > 0}
          >
            Verificar código
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
}
